module.exports = __webpack_public_path__ + "img/icon-4.35f871bb.png";